/* eslint-disable jsx-a11y/anchor-has-content */
import React from 'react'
import _ from 'lodash'
import { connect } from 'react-redux'
import { Header, Segment, Button, Grid } from 'semantic-ui-react'

import firebase from '../../../config/firebase'
import DashboardActions from '../../../reducers/dashboardReducer'

class PayingCustomer extends React.PureComponent {
  state = {
    downloadingActivation: false,
    downloadingRetention: false,
    downloadActivationUrl: '',
    downloadRetentionUrl: '',
  }

  downloadActivationLinkRef = React.createRef()

  downloadRetentionLinkRef = React.createRef()

  onDownloadActivationClick = () => {
    const { payingCustomers } = this.props
    let json = {}

    if (payingCustomers.activation) {
      json = _.map(payingCustomers.activation, (customer, customerKey) => customerKey)
    }

    this.uploadActivationFile(JSON.stringify(json))
  }

  onDownloadRetenttionClick = () => {
    const { payingCustomers } = this.props
    let json = {}

    if (payingCustomers.retention) {
      json = _.map(payingCustomers.retention, (customer, customerKey) => customerKey)
    }

    this.uploadRetentionFile(JSON.stringify(json))
  }

  uploadActivationFile(jsonText) {
    const self = this

    const storage = firebase
      .storage()
      .ref()
      .child(`report/activation-paying-customer.json`)

    this.setState({ downloadingActivation: true })

    storage.putString(jsonText.toString()).then(snapshot => {
      self.downloadActivationFile(snapshot)
    })
  }

  uploadRetentionFile(jsonText) {
    const self = this

    const storage = firebase
      .storage()
      .ref()
      .child(`report/retention-paying-customer.json`)

    this.setState({ downloadingRetention: true })

    storage.putString(jsonText.toString()).then(snapshot => {
      self.downloadRetentionFile(snapshot)
    })
  }

  downloadActivationFile(snapshot) {
    const self = this

    snapshot.ref.getDownloadURL().then(downloadActivationUrl => {
      self.setState({ downloadingActivation: false, downloadActivationUrl }, () => {
        self.downloadActivationLinkRef.click()
      })
    })
  }

  downloadRetentionFile(snapshot) {
    const self = this

    snapshot.ref.getDownloadURL().then(downloadRetentionUrl => {
      self.setState({ downloadingRetention: false, downloadRetentionUrl }, () => {
        self.downloadRetentionLinkRef.click()
      })
    })
  }

  render() {
    const {
      downloadingActivation,
      downloadingRetention,
      downloadActivationUrl,
      downloadRetentionUrl,
    } = this.state
    const { getPayingCustomers, loading, payingCustomers } = this.props

    const disabled = !payingCustomers.retention && !payingCustomers.activation

    return (
      <div>
        <Header size="large">
          Paying Customer
          <Button
            disabled={disabled}
            style={{ float: 'right' }}
            onClick={this.onDownloadActivationClick}
            loading={downloadingActivation}
          >
            Download Activation Report
          </Button>
          <Button
            disabled={disabled}
            style={{ float: 'right' }}
            onClick={this.onDownloadRetenttionClick}
            loading={downloadingRetention}
          >
            Download Retention Report
          </Button>
          <Button style={{ float: 'right' }} onClick={getPayingCustomers} loading={loading}>
            {_.size(payingCustomers) === 0 ? 'Get Data' : 'Refresh Data'}
          </Button>
        </Header>
        <Grid columns="equal" style={{ marginTop: 10 }}>
          <Grid.Column>
            <Segment textAlign="center">
              <Header size="medium">Activation Customers</Header>
              <Header size="medium">
                {payingCustomers.activation ? _.size(payingCustomers.activation) : 0}
              </Header>
            </Segment>
          </Grid.Column>
          <Grid.Column>
            <Segment textAlign="center">
              <Header size="medium">Retention Customers</Header>
              <Header size="medium">
                {payingCustomers.retention ? _.size(payingCustomers.retention) : 0}
              </Header>
            </Segment>
          </Grid.Column>
          <Grid.Column>
            <Segment textAlign="center">
              <Header size="medium">Total Paying Customers</Header>
              <Header size="medium">
                {payingCustomers.retention && payingCustomers.activation
                  ? _.size(payingCustomers.activation) + _.size(payingCustomers.retention)
                  : 0}
              </Header>
            </Segment>
          </Grid.Column>
        </Grid>
        <a
          href={downloadActivationUrl}
          ref={ref => {
            this.downloadActivationLinkRef = ref
          }}
          style={{ display: 'none' }}
        />
        <a
          href={downloadRetentionUrl}
          ref={ref => {
            this.downloadRetentionLinkRef = ref
          }}
          style={{ display: 'none' }}
        />
      </div>
    )
  }
}

const mapStateToProps = ({ dashboard }) => ({
  loading: dashboard.payingCustomersLoading,
  payingCustomers: dashboard.payingCustomers,
})

const mapDispatchToProps = dispatch => ({
  getPayingCustomers: () => dispatch(DashboardActions.getPayingCustomers()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PayingCustomer)



// WEBPACK FOOTER //
// ./src/containers/configurations/Report/PayingCustomerReport.js